import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation deleteMarker($id: Int) {
  deleteMarker(id: $id) {
    id
  }
}`;

function deleteMarker(id) {
  return apollo.client.mutate({
    mutation,
    variables: { id },
  }).then((res) => res.data.deleteMarker);
}

export default deleteMarker;
